import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common'; // Import CommonModule
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from '../services/toast-service';

@Component({
	selector: 'app-toasts',
	imports: [CommonModule, NgbToastModule], // Add CommonModule here
	template: `
		@for (toast of toastService.toasts(); track trackByFn($index, toast)) {
		  <ngb-toast
		    [class]="toast.classname"
		    [autohide]="true"
		    [delay]="toast.delay || 5000"
		    (hidden)="toastService.remove(toast)"
		    >
		    <div class="d-flex justify-content-between align-items-center">
		      <div>
		        @if (toast.text) {
		          {{ toast.text }}
		        } @else {
		          <ng-template [ngTemplateOutlet]="toast.template"></ng-template>
		        }
		      </div>
		      <button
		        type="button"
		        class="btn-close ms-2"
		        aria-label="Close"
		        (click)="toastService.remove(toast)"
		      ></button>
		    </div>
		  </ngb-toast>
		}
		`,
	host: { class: 'toast-container position-fixed top-0 end-0 p-3', style: 'z-index: 1200' },
})
export class ToastsContainer {
	readonly toastService = inject(ToastService);

	trackByFn(index: number, toast: any): number {
		return index;
	}
}